export default __webpack_public_path__ + "static/media/bg2.59fcd176.jpg";